export const StatCard = ({ label, value, hint, icon: Icon, accent = "from-sky-400 to-violet-500", testId, onClick }) => {
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      onClick={onClick}
      data-testid={testId}
      className={`group relative w-full overflow-hidden rounded-2xl border border-border bg-gradient-to-br ${accent} p-[1px] text-left transition-transform duration-300 hover:-translate-y-1 ${onClick ? "cursor-pointer" : ""}`}
    >
      <div className="relative h-full rounded-2xl bg-card/90 p-3.5 backdrop-blur-sm sm:p-5">
        <div className={`pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br ${accent} opacity-25 blur-2xl transition-opacity duration-300 group-hover:opacity-45`} />
        <div className="flex items-start justify-between gap-3">
          <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</span>
          {Icon ? <Icon className={`h-4 w-4 bg-gradient-to-br ${accent} bg-clip-text text-transparent`} style={{ color: "hsl(var(--primary))" }} /> : null}
        </div>
        <div className="mt-2 font-mono text-lg font-semibold tabular-nums sm:mt-3 sm:text-2xl">{value}</div>
        {hint ? <div className="mt-1 text-[11px] leading-snug text-muted-foreground sm:text-xs">{hint}</div> : null}
        {onClick ? <div className="mt-2 text-[10px] uppercase tracking-[0.15em] text-primary opacity-0 transition-opacity duration-300 group-hover:opacity-100">lihat daftar →</div> : null}
      </div>
    </Comp>
  );
};
